import { Component, inject } from '@angular/core';
import { ConfigurationService } from '@core/services';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  standalone: true,
})
export class CookiePolicyComponent {
  configurationService = inject(ConfigurationService);

  get CUSTOMER_NAME() {
    return this.configurationService.configuration.clientName;
  }
}
